module.exports = __webpack_public_path__ + "img/logo.847d5417.svg";